import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AdminPage from './funksjoner/sider/AdminPage';
import HomePage from './funksjoner/sider/HomePage';
import PropertyDetailPage from './funksjoner/sider/PropertyDetailPage';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route element={<HomePage />} path="/" />
        <Route element={<PropertyDetailPage />} path="/eiendom/:propertySlug" />
        <Route element={<AdminPage />} path="/admin" />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
